import api from "./api";

const get = () => {
  return api.get("/api/material/categories");
};

const create = ({ name, unit, isMandatory }) => {
  return api.post("/api/material/categories", { name, unit, isMandatory });
};

const update = (id, payload) => {
  return api.patch(`/api/material/categories/${id}`, payload);
};

const getTypes = (categoryId) => {
  const params = categoryId ? { categoryId } : undefined;
  return api.get("/api/material/types", { params });
};

const createType = ({ name, categoryId }) => {
  return api.post("/api/material/types", { name, categoryId });
};

const updateType = (id, payload) => {
  return api.patch(`/api/material/types/${id}`, payload);
};

const deleteType = (id) => {
  return api.delete(`/api/material/types/${id}`);
};

const MaterialService = {
  get,
  create,
  update,
  getTypes,
  createType,
  updateType,
  deleteType,
};

export default MaterialService;
